import React from 'react';
import { NavLink } from 'react-router-dom';

import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded';

import { AgentAvatar } from 'components/AgentLanding/AgentLandingPrimitives';

const AgentLandingHeader = ({
  agents, logoUrl, cta, search, onBioClick,
}) => (
  <header className="al-site-header">
    <div className={`al-shell al-header-inner${logoUrl ? '' : ' al-header-inner--no-brand'}`}>
      {logoUrl && (
        <NavLink className="al-brand" to={{ pathname: '/', search }} aria-label="Agent landing home">
          <img src={logoUrl} alt="Real estate team or brokerage" />
        </NavLink>
      )}
      <div className="al-header-right">
        <button
          className="al-bio-link"
          type="button"
          aria-haspopup="dialog"
          onClick={onBioClick}
        >
          {agents.length > 1 ? 'Meet your advisors' : 'Meet your advisor'}
          <ArrowForwardRoundedIcon aria-hidden="true" />
        </button>
        <div className="al-header-agents" aria-label={agents.length > 1 ? 'Your local advisors' : 'Your local advisor'}>
          {agents.map((agent) => <AgentAvatar key={`${agent.firstName}-${agent.lastName}`} agent={agent} compact />)}
        </div>
        {cta && !cta.hidden && (cta.href ? (
          <a
            className={`al-header-action al-header-action--${cta.variant || 'outline'}`}
            href={cta.href}
            aria-label={cta.accessibleLabel || cta.label}
            aria-disabled={cta.disabled || undefined}
            onClick={cta.disabled ? (event) => event.preventDefault() : undefined}
          >
            {cta.icon}
            {cta.label}
          </a>
        ) : (
          <button
            className={`al-header-action al-header-action--${cta.variant || 'outline'}`}
            type="button"
            aria-label={cta.accessibleLabel || cta.label}
            disabled={cta.disabled}
            onClick={cta.onClick}
          >
            {cta.icon}
            {cta.label}
          </button>
        ))}
      </div>
    </div>
  </header>
);

export default AgentLandingHeader;
